import React, { Component } from "react";
import { get_data, post_data, isMobile, isIos } from '../../static/helper';
import Coverflow from 'reactjs-coverflow';
import styled from 'styled-components';
import { GA_Event } from '../Analytics/Analytics';
import { horizontalScroll, scrollDown } from '../../static/scrollAnimation';
import Loader from '../Loader/Loader';
import TrackVisibility from 'react-on-screen';

import "./VideosSection.scss"
import Popup from "../Popup/Popup";

const PlaySvg = () => (
    // <svg className="play-svg" xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61">
    //     <defs>
    //     </defs>
    //     <g id="Group_3509" className="cls-1" data-name="Group 3509" transform="translate(-911.5 -1560.5)">
    //         <circle id="Ellipse_13539" cx="30" cy="30" r="30" className="cls-2" data-name="Ellipse 13539" transform="translate(912 1561)" />
    //         <g id="noun_Video_68841" transform="translate(912 1561)">
    //             <path id="Path_3119" d="M37.25 53.121a1.216 1.216 0 0 1-.592-.152 1.239 1.239 0 0 1-.658-1.1V28.776a1.251 1.251 0 0 1 1.938-1.04l17.5 11.547a1.247 1.247 0 0 1 0 2.085l-17.5 11.548a1.243 1.243 0 0 1-.687.2zM38.5 31.1v18.453l13.98-9.222z" className="cls-3" data-name="Path 3119" transform="translate(-13.5 -10.323)" />
    //             <path id="Path_3120" d="M30 2.5A27.5 27.5 0 1 1 2.5 30 27.536 27.536 0 0 1 30 2.5zM30 0a30 30 0 1 0 30 30A30 30 0 0 0 30 0z" className="cls-3" data-name="Path 3120" />
    //         </g>
    //     </g>
    // </svg>
    <svg className="play-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118.83 81.71">
        <defs>
        </defs>
        <title>Asset 3</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path className="cls-1" d="M113.82,7.88C110.59,2.14,107.09,1.09,100,.69S75,0,59.44,0,26,.2,18.88.68,8.26,2.13,5,7.88s-5,15.6-5,33H0c0,17.3,1.71,27.24,5,32.91s6.76,6.78,13.87,7.26,25,.66,40.57.66,33.41-.24,40.53-.65,10.63-1.52,13.86-7.26,5-15.61,5-32.91v-.06C118.87,23.48,117.18,13.61,113.82,7.88Z" />
                <polygon className="cls-2" points="44.56 63.16 44.56 18.58 81.71 40.87 44.56 63.16" />
            </g>
        </g>
    </svg>
);


const Flag = styled.div`
    bottom: -1.145vw;
    left: 0;
    margin: auto;
    right: 0;
    border: 0.104vw #b0b0b0 solid;
    border-radius: 50%;
    position:absolute;
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    background-size: 2.083vw;
    width: 2.083vw;
    height: 2.083vw;
    @media screen and (max-width: 750px) {
        bottom: -3.4375vw;
        border: 0.3125vw #b0b0b0 solid;
        background-size: 6.25vw;
        width: 6.25vw;
        height: 6.25vw;
    }
`;

const VideoGallery = (props) => {
    return (
        <div className="image-container" onClick={(event) => { props.onCountryClick(event, props.index, props.VideoId); }}>
            <img src={`https://i.ytimg.com/vi/${props.VideoId}/mqdefault.jpg`}></img>
            <PlaySvg />
            <Flag className="flag" image={`${process.env.PUBLIC_URL}/static/images/countries/${props.Country}-flag-round-small.png`} />
        </div>
    )
}

const VotesSection = (props) => {
    if (props.currentItem) {
        // const current = props.sliderData.filter(item => { return item.Id === props.position + 1 })[0]

        return (
            <div className={`vote-wrapper ${props.isVisible ? "active" : ""} `}>
                <div className="title">הענק ניקוד ל- <span>{props.currentItem.CountryName}</span></div>
                <div className="scores-container">
                    {props.eight ?
                        <div className="score score8 choosed">
                            <div className="close" onClick={() => props.onScoreChange(8, true)}></div>
                            <img src={`https://i.ytimg.com/vi/${props.eight.VideoId}/mqdefault.jpg`}></img>
                            <Flag className="flag" image={`${process.env.PUBLIC_URL}/static/images/countries/${props.eight.Country}-flag-round-small.png`} />
                        </div>
                        :
                        <div className="score score8" onClick={() => props.onScoreChange(8)}>
                            <div className="score-title">+8</div>
                            <div className="desc">נקודות</div>
                        </div>
                    }
                    {props.ten ?
                        <div className="score score10 choosed">
                            <div className="close" onClick={() => props.onScoreChange(10, true)}></div>
                            <img src={`https://i.ytimg.com/vi/${props.ten.VideoId}/mqdefault.jpg`}></img>
                            <Flag className="flag" image={`${process.env.PUBLIC_URL}/static/images/countries/${props.ten.Country}-flag-round-small.png`} />
                        </div>
                        :
                        <div className="score score10" onClick={() => props.onScoreChange(10)}>
                            <div className="score-title">+10</div>
                            <div className="desc">נקודות</div>
                        </div>
                    }
                    {props.twelve ?
                        <div className="score score12 choosed">
                            <div className="close" onClick={() => props.onScoreChange(12, true)}></div>
                            <img src={`https://i.ytimg.com/vi/${props.twelve.VideoId}/mqdefault.jpg`}></img>
                            <Flag className="flag" image={`${process.env.PUBLIC_URL}/static/images/countries/${props.twelve.Country}-flag-round-small.png`} />
                        </div>
                        :
                        <div className="score score12" onClick={() => props.onScoreChange(12)}>
                            <div className="score-title">+12</div>
                            <div className="desc">נקודות</div>
                        </div>
                    }
                </div>
                {/* <button disabled={!(props.eight && props.ten && props.twelve)} className="send-btn" onClick={props.sentVotes}>שלח בחירה</button> */}
                <button className={`send-btn g-recaptcha ${!(props.eight && props.ten && props.twelve) ? "disable" : ""}`} data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU" disabled={!(props.eight && props.ten && props.twelve)} onClick={() => window.grecaptcha.execute()} data-callback="sentVotes">שלח בחירה</button>
            </div>
        )
    }
    return "";
}

const ScoresSection = (props) => {
    if (props.data && props.data.length > 0) {
        let items = [];
        let length = props.isFullList ? props.data.length : 5;
        let sortData = props.data.slice(0).sort(function (a, b) { return b.Score - a.Score })
        for (let index = 0; index < length; index++) {
            const item = sortData[index];
            items.push(
                <div key={index} className={`score-item place-${index + 1} ${index % 2 === 0 ? "dark" : "light"}`}>
                    <div className="top">
                        <Flag className="flag" image={`${process.env.PUBLIC_URL}/static/images/countries/${item.Country}-flag-round-small.png`} />
                        <h2 className="title">{item.CountryName}</h2>
                        <div className="place">{`#${index + 1}`}</div>
                    </div>
                    <div className="song">{item.SongName}</div>
                    <div className="singer">{item.SingerName}</div>
                    <div className="score-num">
                        <div className="like-img"></div>

                        {item.Score + " points"}
                    </div>
                </div>
            )

        }
        return (
            <div className="scores-container">
                {items}

                <button className="full-list-btn" onClick={props.openFullList}>{props.isFullList ? "סגור" : "לרשימה המלאה"}</button>
                <div></div>
            </div>
        )
    }
    return "";
}

class VideosSection extends Component {
    constructor() {
        super();
        this.state = {
            sliderData: [],
            active: 3,
            position: 0,
            currentItem: {},
            eight: null,
            ten: null,
            twelve: null,
            isFullList: false,
            popupTitle: "",
            popupDesc: "",
            loaderState: false,
            pupupShare: null,
            flagAnimationActive: false,
            animFlag: null
        }
        window.sentVotes = this.sentVotes;
    }
    componentDidMount = async (e) => {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.google.com/recaptcha/api.js';

        document.getElementsByTagName('head')[0].appendChild(script);

        let songsData = await get_data("/api/home/GetSongs");
        const { coverflow } = this.refs;
        let position = (coverflow && coverflow.getPosition()) || Math.round((songsData.length - 1) / 2);
        this.setState({
            sliderData: songsData,
            position,
            currentItem: songsData[position]
        });
        if (window.location.search && window.location.search.indexOf("c=") > -1) {
            const value = this.getParameterByName("c", window.location.search);
            if (value) {
                let currentIndex = 0;
                const current = songsData.map((item, index) => {
                    if (item.Id == value) {
                        currentIndex = index;
                        return;
                    }
                });
                this.setState({
                    currentItem: songsData[currentIndex],
                    position: currentIndex
                });
                this.goAt(currentIndex, e);
                this.props.openYouTubeModal(songsData[currentIndex].VideoId);
            }
        }
    }
    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    openFullList = () => {
        if (!this.state.isFullList) {
            GA_Event("Voating", "full_list");
        }
        document.querySelector(".votes-arrows .left").classList.add("disable");
        document.querySelector(".votes-arrows .right").classList.remove("disable");
        this.setState(prevState => ({ isFullList: !prevState.isFullList }));
    }
    onChange(position) {
        if (this.state.sliderData.length >= position + 1) {
            var currentItem = this.state.sliderData.filter((item, index) => { return index === position })[0]
        }
        this.setState({ position, currentItem });
    }
    onScoreChange = (point, isDeleted) => {
        const { currentItem } = this.state;
        if (this.checkVote(currentItem) || isDeleted) {
            switch (point) {
                case 8:
                    this.setState({ eight: isDeleted ? null : currentItem })
                    break;
                case 10:
                    this.setState({ ten: isDeleted ? null : currentItem })
                    break;
                case 12:
                    this.setState({ twelve: isDeleted ? null : currentItem })
                    break;
            }
        }
        else {
            this.showMessage("לא ניתן להצביע פעמיים לאותה מדינה", "");
        }
    }

    sentVotes = async () => {
        window.grecaptcha.reset();
        let voteModel = [
            {
                CountryId: this.state.eight.Id,
                Score: 8
            },
            {
                CountryId: this.state.ten.Id,
                Score: 10
            },
            {
                CountryId: this.state.twelve.Id,
                Score: 12
            },
        ]
        this.toggleLoader(true);
        let res = await post_data("/api/home", voteModel);
        // set_cookie("user-ip", res.Ip)
        if (res.Title.indexOf("תודה") > -1) {
            GA_Event("Voating", "vote_sent");
        }
        this.toggleLoader(false);
        this.showMessage(res.Title, res.Message);
        this.emptyVotes();

    }

    closePopup = () => {
        let flagAnimationActive = false;
        if (this.state.popupTitle.indexOf("תודה") > -1) {
            flagAnimationActive = true;
            if (isMobile() || isIos()) {
                scrollDown("top-videos-container", -50, 400);
            }
        }
        this.setState({
            isPopupShow: false,
            flagAnimationActive
        });
        if (flagAnimationActive) {
            setTimeout(() => {
                this.setState({
                    flagAnimationActive: false
                })
            }, 4000);
        }
    }

    showMessage = (popupTitle, popupDesc) => {
        let pupupShare = null;

        if (popupTitle.indexOf("תודה") > -1) {
            pupupShare = {
                title: "חביב הקהל באירוויזיון – ynet",
                desc: `היי, בחרתי לתת דוז פואה ל - ${this.state.twelve.CountryName}, בואו לשמוע את השיר שלה!`,
                url: `https://z.ynet.co.il/mshort/content/Eurovision2019?c=${this.state.twelve.Id}#video-section`
            };
        }
        this.setState({
            isPopupShow: true,
            popupTitle,
            popupDesc,
            pupupShare
        })
    }

    emptyVotes = () => {
        this.setState(prevState => ({
            eight: null,
            ten: null,
            twelve: null,
            animFlag: {
                eight: prevState.eight.Country,
                ten: prevState.ten.Country,
                twelve: prevState.twelve.Country
            }
        }))
    }

    checkVote(currentItem) {
        if ((this.state.eight && this.state.eight.Id === currentItem.Id) ||
            (this.state.ten && this.state.ten.Id === currentItem.Id) ||
            (this.state.twelve && this.state.twelve.Id === currentItem.Id)) {
            return false;
        }
        return true;
    }

    next = (e) => {
        e.preventDefault();
        this.refs.coverflow.next();
        this.setState({});
    }
    getPosition = (e) => {
        e.preventDefault();
        return this.refs.coverflow.getPosition();
    }
    prev = (e) => {
        e.preventDefault();
        this.refs.coverflow.previous();
    }
    goAt = (num, e) => {
        if (e) {
            e.preventDefault();
        }
        this.refs.coverflow.goAt(num);
    }

    search = (e) => {
        let index = 0;
        const searchWord = e.target.value.toLowerCase();
        if (searchWord.length >= 2) {
            let temp = this.state.sliderData.findIndex((item) => item.CountryName.indexOf(searchWord) === 0 || item.Country.indexOf(searchWord) === 0);
            if (temp > -1) {
                this.goAt(temp, e);
            }
        }
    }
    scrollRight() {
        const elem = document.querySelector(".countries-score-container");
        const maxScroll = elem.scrollWidth - elem.clientWidth;
        const to = elem.scrollLeft + 150;
        horizontalScroll(elem, to, 300);

        if (to <= maxScroll) {
            document.querySelector(".votes-arrows .left").classList.remove("disable");
        }
        else {
            document.querySelector(".votes-arrows .right").classList.add("disable");
        }
        // ele
    }

    scrollLeft() {
        const elem = document.querySelector(".countries-score-container");
        const maxScroll = 0;
        const to = elem.scrollLeft - 150;
        horizontalScroll(elem, elem.scrollLeft - 150, 300);
        if (to >= maxScroll) {
            document.querySelector(".votes-arrows .right").classList.remove("disable");
        }
        else {
            document.querySelector(".votes-arrows .left").classList.add("disable");
        }
    }

    onCountryClick = (event, index, videoId) => {
        if (index === this.state.position) {
            this.props.openYouTubeModal(videoId)
        }
        else {
            this.goAt(index, event)
        }
    }
    toggleLoader = (flag) => {
        this.setState({ loaderState: flag })
    }
    render() {
        let sliderData = [];
        this.state.sliderData.map((item, index) => {
            sliderData.push(<VideoGallery key={index} goAt={this.goAt} onCountryClick={this.onCountryClick} index={index} openYouTubeModal={this.props.openYouTubeModal} {...item} />)
        })

        return (
            <div className="video-section" id="video-section">
                <Loader active={this.state.loaderState} />
                {this.state.isPopupShow ?
                    <Popup
                        title={this.state.popupTitle}
                        desc={this.state.popupDesc}
                        closePopup={this.closePopup}
                        pupupShare={this.state.pupupShare}
                    />
                    : ""
                }
                <div className={`video-container  ${this.state.isFullList ? "open" : "close"}`}>
                    <div className="video-wrapper">
                        <div className="title-container">
                            <div className="image"></div>
                            <div className="title">דוז פואה!</div>
                        </div>
                        <div className="description">
                            גולשי ynet בוחרים את חביב הקהל של אירוויזיון 2019. בואו לבחור את הנציגים הנבחרים שלכם.
                            <div>*מעודכן לפי השירים שפורסמו</div>
                        </div>
                        <div className="search-container">
                            <input placeholder="חפש מדינה" className="search" type="text" onChange={this.search} />
                        </div>
                        <div className="video-coverflow">
                            {sliderData.length > 0 ?
                                <Coverflow ref="coverflow"
                                    style={{ width: "100%", height: "100%" }}
                                    margin={"0px"}
                                    startPosition={Math.round((this.state.sliderData.length - 1) / 2)}
                                    enableScroll={true}
                                    rotate={45}
                                    animationSpeed={0.8}
                                    onChange={position => this.onChange(position)}>
                                    {sliderData}
                                </Coverflow>
                                : ""
                            }
                            <TrackVisibility partialVisibility once>
                                <VotesSection
                                    onScoreChange={this.onScoreChange}
                                    eight={this.state.eight}
                                    ten={this.state.ten}
                                    twelve={this.state.twelve}
                                    currentItem={this.state.currentItem}
                                    sentVotes={this.sentVotes}
                                />
                            </TrackVisibility>

                            <div className="arrows">
                                <div onClick={this.next} className="arrow right"></div>
                                <div onClick={this.prev} className="arrow left"></div>
                            </div>
                        </div>

                    </div>
                    <div className={`top-videos-container ${this.state.isFullList ? "open" : "close"}`}>
                        {this.state.flagAnimationActive && this.state.animFlag ?
                            <div className={`anim-flags-container ${this.state.flagAnimationActive ? "active" : ""}`}>
                                <div className="anim-flags">
                                    <Flag className="flag place3" image={`${process.env.PUBLIC_URL}/static/images/countries/${this.state.animFlag.eight}-flag-round-small.png`} />
                                    <Flag className="flag place1" image={`${process.env.PUBLIC_URL}/static/images/countries/${this.state.animFlag.twelve}-flag-round-small.png`} />
                                    <Flag className="flag place2" image={`${process.env.PUBLIC_URL}/static/images/countries/${this.state.animFlag.ten}-flag-round-small.png`} />
                                </div>
                            </div>
                            : ""
                        }
                        <button className="close-btn" onClick={this.openFullList}></button>
                        <div className="arrows votes-arrows">
                            <button className="arrow right" onClick={this.scrollRight}></button>
                            <button className="arrow left disable" onClick={this.scrollLeft}></button>
                        </div>

                        <div className="top-wrapper">
                            <h2 className="title">{this.state.isFullList ? "הרשימה המלאה" : "TOP 5"}</h2>
                            <div className="logo"></div>
                        </div>
                        <div className="countries-score-container">
                            <ScoresSection
                                openFullList={this.openFullList}
                                isFullList={this.state.isFullList}
                                data={this.state.sliderData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VideosSection;



// WEBPACK FOOTER //
// ./src/Components/VideosSection/VideosSection.jsx